import { Target, Award, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Strategic Roadmap",
  description: "We design data-driven frameworks that align institutional goals with measurable student outcomes and sustainable growth.",
  icon: Target
}, {
  title: "Proven Excellence",
  description: "Our consultants bring decades of leadership experience from top-tier academic institutions and global education networks.",
  icon: Award
}, {
  title: "Future-Ready Focus",
  description: "We bridge the gap between traditional pedagogy and emerging technology, ensuring your institution leads in the digital age.",
  icon: ShieldCheck
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34844" id="why-choose-edustrategy-group" className="bg-[#1B2A4A] text-[#F5F5F5] py-24">
      <div className="container mx-auto px-6">
        <div ref={ref} className={cn("transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-center text-3xl md:text-5xl font-bold font-serif tracking-tight mb-16 text-[#F5F5F5]">
            Why Choose EduStrategy Group
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, i) => <div key={i} data-index={i} className="h-full">
                <Card className="h-full bg-[#1B2A4A] rounded border border-white/10 shadow-none hover:-translate-y-2 transition-transform duration-400 ease-[cubic-bezier(0.25,0.8,0.25,1)]">
                  <CardHeader className="pb-4 pt-8 px-8">
                    <div className="mb-6 inline-flex">
                      <feature.icon className="w-12 h-12 text-[#2A7F7F]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-serif font-semibold text-[#F5F5F5]">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-8">
                    <CardDescription className="text-base font-sans text-[#D1D5DB] leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}